import { render, staticRenderFns } from "./RateUsItem.vue?vue&type=template&id=e26582ae&"
import script from "./RateUsItem.vue?vue&type=script&lang=ts&"
export * from "./RateUsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports